export class ThirdPartyApiServiceError extends Error {
    constructor(error: any) { // TODO add additional error handling
        super(error);
    }
}